import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';

import { InputNumberComponent } from './components/input-number/input-number.component';
import { InputRegexComponent } from './components/input-regex/input-regex.component';
import { FormValidateDirective } from './directives/form-validate.directive';

import { CheckBoxComponent } from './components/check-box/check-box.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { InputCodeConfirmationComponent } from './components/input-code-confirmation/input-code-confirmation.component';
import { InputEmailComponent } from './components/input-email/input-email.component';
import { InputLettersComponent } from './components/input-letters/input-letters.component';
import { InputResendEmailComponent } from './components/input-resend-email/input-resend-email.component';
import { SelectComponent } from './components/select/select.component';

import { CheckBoxLegalComponent } from './components/check-box-legal/check-box-legal.component';
import { InputTextComponent } from './components/input-text/input-text.component';

import { MOLayoutModule } from '../mo-layout/mo-layout.module';
import { InputCreditCardExpirationComponent } from './components/input-credit-card-expiration/input-credit-card-expiration.component';
import { InputNitRegexComponent } from './components/input-nit-regex/input-nit-regex.component';
import { InputOtpCodeComponent } from './components/input-otp-code/input-otp-code.component';
import { InputPasswordComponent } from './components/input-password/input-password.component';
import { InputUrlComponent } from './components/input-url/input-url.component';
import { TestCompComponent } from './components/test-comp/test-comp.component';

const COMPONENTS = [
  CheckBoxComponent,
  InputCodeConfirmationComponent,
  InputResendEmailComponent,
  SelectComponent,
  DatePickerComponent,
  InputTextComponent,
  CheckBoxLegalComponent,
  InputNitRegexComponent,
  InputUrlComponent,
  TestCompComponent,
  InputOtpCodeComponent,
  InputRegexComponent,
  InputNumberComponent,
  InputLettersComponent,
  InputEmailComponent,
  InputPasswordComponent,
  InputCreditCardExpirationComponent,
];

const MATERIAL = [
  MatCheckboxModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatFormFieldModule,
  MatInputModule,
  MatDialogModule,
  MatSelectModule,
  MatIconModule,
  MatMenuModule,
];

const REACTIVE_FORMS = [FormsModule, ReactiveFormsModule];
const DIRECTIVES = [FormValidateDirective];

@NgModule({
  declarations: [...DIRECTIVES, ...COMPONENTS],
  imports: [CommonModule, MOLayoutModule, ...REACTIVE_FORMS, ...MATERIAL],
  exports: [...REACTIVE_FORMS, ...MATERIAL, ...COMPONENTS, ...DIRECTIVES],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-CO' }],
})
export class MOFormsModule {}
